import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    iconProperties: {
        home: {
            bottom: 100,
            right: 40
        },
        "buy-used-cars": {
            bottom: 100,
            right: 40
        },
        "car-listing": {
            bottom: 100,
            right: 40
        },
        "car-detail": {
            bottom: 100,
            right: 40
        },
        "car-details-checkout": {
            bottom: 100,
            right: 40
        }
    }
};

export const setIconProperty = (state = INITIAL_STATE, { page, properties }) => {
    return {
        ...state,
        iconProperties: {
            ...state.iconProperties,
            [page]: {
                ...(state.iconProperties[page] || {}),
                ...properties
            }
        }
    };
};

export const HANDLERS = {
    [Types.SET_ICON_PROPERTY]: setIconProperty
};

export default createReducer(INITIAL_STATE, HANDLERS);
